export default function BenefitsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Benefits of Selling <span className="text-teal-600">As-Is to Us</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choosing to sell your hoarder house to TREX RE LLC provides numerous advantages over traditional selling methods.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/6b851603e7ef24391b2d340ab7961160.jpg"
              alt="Stress-free home selling experience"
              className="w-full h-96 object-cover rounded-xl shadow-lg"
            />
          </div>

          <div className="space-y-6">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Save Months of Time</h3>
                <p className="text-gray-700 leading-relaxed">
                  Cleaning out a hoarder house can take 3-6 months or longer. Selling traditionally adds another 3-6 months. We can close in as little as 7 days, saving you nearly a year of stress and effort.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Save Thousands in Costs</h3>
                <p className="text-gray-700 leading-relaxed">
                  Between cleanup costs, repairs, real estate commissions, and holding costs, traditional selling can cost $30,000-$80,000 or more. We handle everything, so you keep more money in your pocket.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Guaranteed Sale</h3>
                <p className="text-gray-700 leading-relaxed">
                  No waiting for buyer financing to fall through or deals to collapse. We pay cash and close on schedule. Once you accept our offer, the sale is guaranteed.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-emotion-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Reduce Emotional Stress</h3>
                <p className="text-gray-700 leading-relaxed">
                  Avoid the emotional toll of sorting through belongings, making difficult decisions, and dealing with the physical labor of cleanup. We handle it all so you can focus on moving forward.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Maintain Privacy</h3>
                <p className="text-gray-700 leading-relaxed">
                  No open houses, no parade of strangers walking through the property, no nosy neighbors seeing the condition. We handle everything discreetly and professionally.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-10">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Compare Your Options</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-gray-200">
                  <th className="text-left py-4 px-4 text-gray-900 font-bold">Factor</th>
                  <th className="text-center py-4 px-4 text-teal-600 font-bold">Sell to TREX RE LLC</th>
                  <th className="text-center py-4 px-4 text-gray-600 font-bold">Traditional Sale</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Cleanup Required</td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                      <i className="ri-close-line mr-1"></i> None
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800">
                      <i className="ri-check-line mr-1"></i> Required
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Timeline to Close</td>
                  <td className="py-4 px-4 text-center text-teal-600 font-bold">7-14 Days</td>
                  <td className="py-4 px-4 text-center text-gray-600">6-12 Months</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Out-of-Pocket Costs</td>
                  <td className="py-4 px-4 text-center text-teal-600 font-bold">$0</td>
                  <td className="py-4 px-4 text-center text-gray-600">$30,000-$80,000+</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Repairs Needed</td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                      <i className="ri-close-line mr-1"></i> None
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800">
                      <i className="ri-check-line mr-1"></i> Extensive
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Agent Commissions</td>
                  <td className="py-4 px-4 text-center text-teal-600 font-bold">$0</td>
                  <td className="py-4 px-4 text-center text-gray-600">5-6% ($15,000+)</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Showing Property</td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                      <i className="ri-close-line mr-1"></i> Not Required
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800">
                      <i className="ri-check-line mr-1"></i> Multiple Times
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold text-gray-900">Sale Certainty</td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                      <i className="ri-check-line mr-1"></i> Guaranteed
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-800">
                      <i className="ri-question-line mr-1"></i> Uncertain
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
